


export default class OptionUtils {
  
  static SortByValue = function(a,b) {
    if (a.value() > b.value()) {
      return 1;
    }
    if (a.value() < b.value()) {
      return -1;
    }
    return 0;
  }
  
  // Positions are stored as text ("1", "2", "10"); compared as numbers when both are, so
  // Note 10 comes after Note 2, and as text otherwise.
  static SortByPosition = function(a,b) {
    const pa = String(a.position() ?? '').trim();
    const pb = String(b.position() ?? '').trim();
    const na = Number(pa);
    const nb = Number(pb);
    if (pa !== '' && pb !== '' && Number.isFinite(na) && Number.isFinite(nb) && na !== nb) {
      return na < nb ? -1 : 1;
    }
    if (pa > pb) {
      return 1;
    }
    if (pa < pb) {
      return -1;
    }
    return 0;
  }
}
